import Tabs, { ITab } from "@/components/Tabs";
import { HeaderTextBlock, TypographyContainer } from "@/components/Typography";
import { useUser } from "@/requests/hooks/user";
import { doesUserHaveScope } from "@/utils/doesUserHaveScope";
import { IFeatureFlagKeys } from "@/utils/featureFlags";
import { useFlags } from "flagsmith/react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

const WidgetController = () => {
  const { t } = useTranslation();
  const { data: user } = useUser();
  const flags = useFlags<IFeatureFlagKeys>([
    "sms-extension-enabled",
    "web-app-widget-settings-enabled",
  ]);
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (pathname.endsWith("widget")) navigate("preview");
  }, [pathname]);

  const shouldDisplayWidgetLocation = doesUserHaveScope(
    "MANAGE_SHOPIFY_WIDGET_LOCATION",
    user?.scopes,
  );

  const shouldDisplaySmsInstallation =
    doesUserHaveScope("LIST_SMS_CONTACTS", user?.scopes) &&
    flags?.["sms-extension-enabled"]?.enabled;

  const tabs: ITab[] = [
    {
      title: t("settings.widgetSettings.tabs.preview"),
      path: "preview",
      isVisible: true,
    },
    {
      title: t("settings.widgetSettings.tabs.location"),
      path: "location",
      isVisible: shouldDisplayWidgetLocation,
    },
    {
      title: t("settings.widgetSettings.tabs.privacy"),
      path: "privacy-details",
      isVisible: true,
    },
    {
      title: t("settings.widgetSettings.tabs.emailInstallation"),
      path: "email-installation",
      isVisible: true,
    },
    {
      title: t("settings.widgetSettings.tabs.smsInstallation"),
      path: "sms-installation",
      isVisible: shouldDisplaySmsInstallation,
    },
  ];

  return (
    <>
      <TypographyContainer>
        <HeaderTextBlock
          align="left"
          featureText={t("settings.widgetSettings.header.feature")}
          headingText={t("settings.widgetSettings.header.heading")}
        />
      </TypographyContainer>
      <div className="mt-2">
        <Tabs tabs={tabs} />
        <div className="mt-50">
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default WidgetController;
